import { render, staticRenderFns } from "./StudentRelationModal__Style#Drawer.vue?vue&type=template&id=5427812c&scoped=true"
import script from "./StudentRelationModal__Style#Drawer.vue?vue&type=script&lang=js"
export * from "./StudentRelationModal__Style#Drawer.vue?vue&type=script&lang=js"
import style0 from "./StudentRelationModal__Style#Drawer.vue?vue&type=style&index=0&id=5427812c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5427812c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5427812c')) {
      api.createRecord('5427812c', component.options)
    } else {
      api.reload('5427812c', component.options)
    }
    module.hot.accept("./StudentRelationModal__Style#Drawer.vue?vue&type=template&id=5427812c&scoped=true", function () {
      api.rerender('5427812c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/studentRelation/modules/StudentRelationModal__Style#Drawer.vue"
export default component.exports